import { render, staticRenderFns } from "./KkScrollbar.vue?vue&type=template&id=fe836592"
import script from "./KkScrollbar.vue?vue&type=script&lang=js"
export * from "./KkScrollbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports